/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Full_Notice_TitleInputs */



/**
* | output |
* | --- |
* | "Guardrails Feature - Full Usage Notice" |
*
* @param {Guardrails_Full_Notice_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_full_notice_title = /** @type {((inputs?: Guardrails_Full_Notice_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Full_Notice_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungshinweis - Guardrails Funktion")
	return /** @type {LocalizedString} */ ("Guardrails Feature - Full Usage Notice")
});